import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import LanguageSwitcher from "../../utils/LanguageSwitcher/LanguageSwitcher";
import "../auth.card.css";

export const Login = ({ emailRef, errorField = "", errorMessage = "", isSubmitting = false }) => {
  const { t } = useTranslation();

  return (
    <div className="auth-card">
      <div className="auth-card-language">
        <LanguageSwitcher />
      </div>
      <h1>{t("auth.login")}</h1>

      <div className="auth-field">
        <label htmlFor="login-email">{t("auth.email")}</label>
        <input
          aria-describedby={errorField === "credentials" ? "login-error" : undefined}
          aria-invalid={errorField === "credentials"}
          autoComplete="email"
          id="login-email"
          name="email"
          placeholder="user@example.com"
          ref={emailRef}
          required
          type="email"
        />
      </div>

      <div className="auth-field">
        <label htmlFor="login-password">{t("auth.password")}</label>
        <input
          aria-describedby={errorField === "credentials" ? "login-error" : undefined}
          aria-invalid={errorField === "credentials"}
          autoComplete="current-password"
          id="login-password"
          name="password"
          required
          type="password"
        />
      </div>

      <p className="auth-message auth-message-error" id="login-error" role="alert">
        {errorMessage}
      </p>

      <button disabled={isSubmitting} type="submit">
        {isSubmitting ? t("auth.signingIn") : t("auth.submit")}
      </button>

      <Link to="../auth/signup">{t("auth.signUp")}</Link>
    </div>
  );
};
